import { computed, openBlock, createElementBlock, Fragment, renderList, createBlock, Transition, withCtx, createVNode, mergeProps, createCommentVNode, renderSlot } from "vue";
import UikitToast from "./Toast.vue.es.js";
import { useToastsStore } from "../../uikit.stores/toasts.es.js";
/* empty css                */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = { class: "uikit-toaster" };
const _hoisted_2 = {
  key: 0,
  class: "toast-stack"
};
const _sfc_main = {
  __name: "Toaster",
  setup(__props) {
    const toasterStore = useToastsStore();
    const toasts = computed(() => {
      return [...toasterStore.toasts].reverse();
    });
    const hasToasts = computed(() => toasterStore.hasToasts);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        hasToasts.value ? (openBlock(), createElementBlock("div", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(toasts.value, (toast) => {
            return openBlock(), createBlock(Transition, {
              key: toast.id,
              name: "slide"
            }, {
              default: withCtx(() => [
                createVNode(UikitToast, mergeProps({ ref_for: true }, toast), null, 16)
              ]),
              _: 2
            }, 1024);
          }), 128))
        ])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
};
const Toaster = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-10a1a821"]]);
export {
  Toaster as default
};
//# sourceMappingURL=Toaster.vue.es.js.map
